"use strict";

exports.__esModule = true;
exports.MultiSelect = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _VirtualScroller = require("./VirtualScroller");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Target = _styledComponents["default"].div.withConfig({
  displayName: "MultiSelect__Target",
  componentId: "sc-1utxszj-0"
})(["display:flex;align-items:center;width:100%;"]);
var MultiSelect = exports.MultiSelect = function MultiSelect(props) {
  var button = props.button,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? [] : _props$selected,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$usePortal = props.usePortal,
    usePortal = _props$usePortal === void 0 ? false : _props$usePortal,
    _props$popoverProps = props.popoverProps,
    popoverProps = _props$popoverProps === void 0 ? {} : _props$popoverProps,
    _props$tagInputProps = props.tagInputProps,
    tagInputProps = _props$tagInputProps === void 0 ? {} : _props$tagInputProps,
    _props$position = props.position,
    position = _props$position === void 0 ? _core.Position.BOTTOM_LEFT : _props$position;
  var _useState = (0, _react.useState)(""),
    searchText = _useState[0],
    setSearchText = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var inputEl = (0, _react.useRef)(null);
  var isInitialMount = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else if (inputEl.current) {
      inputEl.current.focus();
    }
  }, [selected.length]);
  var renderTag = function renderTag(item) {
    var renderItemText = props.renderItemText;
    return renderItemText(item);
  };
  var ChildrenButton = button;
  return /*#__PURE__*/_react["default"].createElement(_core.Popover, _extends({
    disabled: disabled,
    usePortal: usePortal,
    canEscapeKeyClose: true,
    enforceFocus: false,
    autoFocus: false,
    position: position,
    captureDismiss: true,
    popoverClassName: _core.Classes.MULTISELECT_POPOVER,
    modifiers: {
      preventOverflow: {
        enabled: false
      },
      hide: {
        enabled: false
      },
      arrow: {
        enabled: false
      }
    },
    onOpened: function onOpened() {
      if (inputEl.current) {
        inputEl.current.focus();
      }
    }
  }, popoverProps, {
    /* Keep after popoverProps so callers cannot wipe open-state / content. */
    isOpen: isOpen,
    onInteraction: function onInteraction(nextOpenState) {
      if (!disabled) {
        setIsOpen(nextOpenState);
      }
    },
    content: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_VirtualScroller.VirtualScroller, _extends({
      searchText: searchText
    }, props)))
  }), /*#__PURE__*/_react["default"].createElement(Target, null, ChildrenButton ? /*#__PURE__*/_react["default"].createElement(ChildrenButton, {
    elementRef: function elementRef(el) {
      inputEl.current = el;
    }
  }) : /*#__PURE__*/_react["default"].createElement(_core.TagInput, _extends({
    fill: true
  }, tagInputProps, {
    inputRef: function inputRef(el) {
      inputEl.current = el;
    },
    inputValue: searchText,
    onInputChange: function onInputChange(event) {
      return setSearchText(event.target.value);
    },
    values: selected.map(function (item) {
      return renderTag(item);
    }) || []
  }))));
};